import React from 'react';
import { ClassAssembly8A2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly8A2026/>;
  };
  
  export default ClassAssemblyPage;